@if (isDisplayProfileDenied) {
  <icz-alert
    class="mx-16 my-32" heading="Nemáte dostatečné oprávnění pro zobrazení informací o doručení"
    severity="info"
  ></icz-alert>
}
@if (isDisplayProfileAllowed) {
  <div
    [waiting]="loadingService.isLoading$(this.plainComponentVersionViewerDialogService) | async"
    class="col grow"
  >
    <div [formGroup]="form" class="row grow gap-48">
      <div class="col grow">
        <icz-section boxed class="block mb-32" label="Zásilka">
          <ng-container formGroupName="uid">
            <icz-form-field formControlName="uid" label="Identifikátor zásilky"></icz-form-field>
          </ng-container>
          <icz-form-field formControlName="label" label="Název"></icz-form-field>
          <ng-container formGroupName="auditInfo">
            <icz-form-autocomplete [options]="functionalPositionOptions$ | async"
              formControlName="createdByFunctionalPositionId"
            label="Založil"></icz-form-autocomplete>
            <div class="row-16 grow">
              <icz-date-picker class="grow" formControlName="createdAt" label="Založeno"></icz-date-picker>
              <icz-date-picker class="grow" formControlName="modifiedAt" label="Poslední úprava"></icz-date-picker>
            </div>
          </ng-container>
          @if (isPaperConsignment) {
            <icz-checkbox
              label="Do vlastních rukou" formControlName="toOwnHands">
            </icz-checkbox>
          }
        </icz-section>
        <icz-section boxed class="block mb-32" label="Doručení">
          <icz-form-field [fieldDisabled]="true" [value]="deliveryTypeName" label="Způsob doručení"></icz-form-field>
          @if (isPaperConsignment || isInternalDelivery) {
            <div class="row">
              @if (isInternalDelivery) {
                <icz-org-structure-selector class="grow" controlName="addresseeOrgUnitId" [disableOrganizationStructureType]="OrganizationStructureType.FUNCTIONAL_POSITION" [form]="form" label="Adresát"></icz-org-structure-selector>
              } @else {
                <icz-form-tree-selector
                  class="grow"
                  formControlName="addresseeFunctionalPositionId"
                  [options]="functionalPositionOptionsWithId$ | async"
                  label="Adresát"
                ></icz-form-tree-selector>
              }
              <icz-form-autocomplete class="grow" formControlName="filingOfficeSheetNodeId" label="Podatelna" [options]="sheetNodesOptions"></icz-form-autocomplete>
            </div>
          }
          @if (isOnPlaceDeliveryType || isPostDelivery) {
            <icz-form-autocomplete [options]="basicServiceWithDistributorOptions" class="grow"
                                   formControlName="basicServiceId"
                                   label="Druh zásilky"></icz-form-autocomplete>
            @if (isConsignmentRecommended) {
              <icz-form-field formControlName="postingNumber" label="Podací číslo"></icz-form-field>
              <div>
                @if (isPostDelivery) {
                  <icz-form-field formControlName="senderPostOffice"
                                  label="Podací pošta"></icz-form-field>
                }
                <icz-checkbox class="mb-8" formControlName="personalDelivery" label="Do vlastních rukou"></icz-checkbox>
              </div>
            }
          }
          @if (isDataBoxDelivery) {
            <div>
              <icz-form-field formControlName="externalId" label="Označení příchozí zásilky">
                <icz-icon suffix size="small" svgIcon="info" iczTooltip="Např. ID zprávy"></icz-icon>
              </icz-form-field>
            </div>
          }
          @if (isInternalDelivery) {
            <div>
              <icz-form-field formControlName="senderInternalOrgUnit"
              label="Organizační jednotka odesílatele"></icz-form-field>
              <icz-form-field [fieldDisabled]="true" [value]="senderInternalAddress | address | async"
              label="Adresa"></icz-form-field>
            </div>
          }
          <div class="row">
            @if (isDigitalDelivery) {
              <icz-date-picker class="grow" formControlName="dispatchDate" [label]="isDataBoxDelivery ? 'Datum dodání' : 'Datum odeslání'" [fieldDisabled]="isDataBoxDelivery"></icz-date-picker>

              @if (isDataBoxDelivery || isDispatchTimeDisabled) {
                <icz-form-field [fieldDisabled]="true" class="grow" [value]="dispatchTimeValue" [label]="isDataBoxDelivery ? 'Čas dodání' : 'Čas odeslání'"></icz-form-field>
              } @else {
                <icz-time-picker class="grow" formControlName="dispatchTime" [label]="isDataBoxDelivery ? 'Čas dodání' : 'Čas odeslání'" [withSeconds]="true"></icz-time-picker>
              }
            } @else {
              <icz-date-picker class="grow" formControlName="dispatchDate" label="Datum odeslání" [fieldDisabled]="isDigitalInternalConsignment"></icz-date-picker>
            }
            <div class="row grow-2">
              <icz-date-picker class="grow-2 mr-8" formControlName="deliveryDate" label="Datum doručení">
                @if (deliveryTimeTooltip) {
                  <icz-icon size="small" suffix [iczTooltip]="deliveryTimeTooltip" svgIcon="info"></icz-icon>
                }
              </icz-date-picker>
              @if (isDeliveryTimeDisabled) {
                <icz-form-field [fieldDisabled]="true" class="grow" [value]="deliveryTimeValue" label="Čas doručení"></icz-form-field>
              } @else {
                <icz-time-picker class="grow" formControlName="deliveryTime" label="Čas doručení" [withSeconds]="true"></icz-time-picker>
              }
            </div>
          </div>
          @if (isPostDelivery) {
            <icz-form-field class="grow" label="Barcode" testingFeature></icz-form-field>
          }
          @if (isDataBoxDelivery) {
            <div>
              <icz-form-field [fieldDisabled]="true" [value]="empowermentValue | empowerment"
              label="Zmocnění"></icz-form-field>
              <icz-form-field [fieldDisabled]="true" [value]="personalDelivery | localizedBoolean" class="grow" label="Do vlastních rukou"></icz-form-field>
              <div class="row">
                <icz-form-field class="grow" formControlName="consigneeOrganisationUnit"
                label="Organizační jednotka příjemce"></icz-form-field>
                <icz-form-field class="grow" formControlName="toHands" label="K rukám"></icz-form-field>
              </div>
            </div>
          }
          @if (isInternalDelivery) {
            <div>
              <icz-form-field [fieldDisabled]="true" [value]="empowermentValue | empowerment"
              label="Zmocnění"></icz-form-field>
              <icz-form-field class="grow" formControlName="senderFileRefNumber" label="Spisová značka odesílatele"></icz-form-field>
              <div class="row">
                <icz-form-field class="grow" formControlName="consignorRefNumber"
                label="Číslo jednací adresáta"></icz-form-field>
                <icz-form-field class="grow" formControlName="consignorFileRefNumber"
                label="Spisová značka adresáta"></icz-form-field>
              </div>
            </div>
          }
        </icz-section>
        <icz-section boxed class="block mb-32" label="Doručené množství">
          @if (hasDigitalReceivedComponents) {
            <icz-form-field class="grow" formControlName="digitalComponentCount"
            label="Počet digitálních komponent"></icz-form-field>
          }
          @if (hasAnalogReceivedComponents) {
            <icz-form-field label="Počet listinných součástí" class="grow" [value]="formattedPaperComponentsCount" [fieldDisabled]="true">
              <icz-icon suffix size="small" iczTooltip="fe.ui.paperComponentsCount.tooltip" svgIcon="info"></icz-icon>
            </icz-form-field>
            <icz-form-field class="grow" formControlName="nonPaperComponentTypeAndCount"
            label="Počet a druh nelistinných součástí"></icz-form-field>
          }
        </icz-section>
        @if (paperConsignmentHasEnvelope) {
          <icz-section boxed class="block mb-32" label="Obálka zásilky">
            <icz-essl-component-link
              [documentEsslComponent]="envelopePaperComponent!"
              [versionId]="receivedPaperConsignment!.envelopeComponentId!"
              [isReadonly]="true"
            ></icz-essl-component-link>
          </icz-section>
        }
        @if (isEmailDelivery) {
          <icz-delivery-info-email
            [consignment]="receivedDigitalConsignment"
            [form]="form"
          ></icz-delivery-info-email>
        }
      </div>
      <div class="col grow">
        @if (consignment && consignmentDistributionClass) {
          <icz-receive-consignment-display-sender
            [consignmentDistributionClass]="consignmentDistributionClass"
            [form]="form"
            [isDocumentDeactivated]="isDocumentDeactivated"
            [isTelefaxConsignment]="isTelefaxConsignment"
            [receivedDigitalConsignment]="receivedDigitalConsignment"
            [receivedPaperConsignment]="receivedPaperConsignment"
            [receivedTelefaxConsignment]="receivedTelefaxConsignment"
            [senderOU]="senderOU"
            (senderRemoved)="wasSenderRemoved = true"
            [senderSubjectId]="consignment.sender!">
          </icz-receive-consignment-display-sender>
        }
        @if (wasSenderRemoved) {
          <icz-section label="Rychlá identifikace odesílatele">
            <div class="col grow">
              <icz-receive-consignment-set-sender
                (anonymousSenderSet)="anonymousSenderSet($event)"
                (senderAddressSet)="setSenderAddress($event)"
                (senderSet)="setSender($event)"
                [form]="form"
                [withAddressSelection]="!isEmailDelivery"
              ></icz-receive-consignment-set-sender>
              <icz-validation-errors-list [control]="senderDefinitionControl" [wrapInAlert]="true"></icz-validation-errors-list>
            </div>
          </icz-section>
        }
        <icz-section [boxed]="true" [expanded]="false" label="Údaje o odesílateli zadané při přijetí" class="mb-32">
          <icz-form-field class="grow" formControlName="originalSender" label="Původní odesílatel" [autoSizeMax]="4" ></icz-form-field>
        </icz-section>
        @if (digitalConsignmentHasProtocolAndOriginal) {
          @if (isDigitalConsignment && digitalConsignmentDefectsCount) {
            <icz-alert class="mb-32" severity="error" [heading]="defectsAlertHeading" [textContext]="{count: digitalConsignmentDefectsCount}">
              <icz-button extraContent label="Přejít na seznam komponent" (onAction)="openDocumentComponents()"></icz-button>
            </icz-alert>
          }
          <icz-section [boxed]="true" label="Protokol a originál datové zprávy">
            <div class="row pt-12">
              <icz-button (onAction)="showProtocolDigital()" label="Zobrazit protokol"></icz-button>
              <icz-button (onAction)="showOriginal()" label="Zobrazit originál"></icz-button>
              @if (hasHeaderDataboxMessage) {
                <icz-button (onAction)="showHeaderDataboxMessage()" label="Zobrazit hlavičku"></icz-button>
              }
              @if(isDataBoxDelivery) {
                <icz-button (onAction)="verifyDataboxConsignment()" label="Ověřit datovou zprávu"></icz-button>
              }
            </div>
          </icz-section>
        }
        @if (personalConsignmentVerificationProtocol) {
          <icz-section [boxed]="true" label="Protokol o výsledku ověření obsahu">
            <div class="row">
              <div class="col grow">
                <icz-button (onAction)="showProtocolPersonal()" label="Zobrazit protokol"></icz-button>
              </div>
              <div class="col grow"></div>
            </div>
          </icz-section>
        }
        @if (isPortalConsignment) {
          <icz-section [boxed]="true" label="Doručení portálem">
            <icz-form-autocomplete
              formControlName="targetDistributionNodeId"
              label="Adresa portálu"
              [options]="portalDistributionNodeOptions"
            ></icz-form-autocomplete>
          </icz-section>
        }
      </div>
    </div>
  </div>
}
